export const RouteParts = {
  FRONT_DESK: 'front-desk',
  POS: 'pos',
  KID_ZONE: 'kid-zone',
  KID_ZONE_HISTORY: 'history',
  BOOKING: 'booking',
  BOOKING_CALENDAR: 'calendar',
  BOOKING_RESOURCES: 'resources',
  BOOKING_RESOURCE_NEW: 'resources/new',
  BOOKING_RESOURCE_EDIT: 'resources/:id/edit',
  MEMBERS: 'members',
  MEMBER_NEW: 'new',
  MEMBER_VIEW: ':id',
  EMPLOYEES: 'employees',
  EMPLOYEE_NEW: 'new',
  EMPLOYEE_VIEW: ':id',
  EMPLOYEE_EDIT: ':id/edit',
  CRM: 'crm',
  CRM_TASKS: 'tasks',
  CRM_LEADS: 'leads',
  CRM_LEAD_NEW: 'leads/new',
  CRM_LEAD_VIEW: 'leads/:id',
  CRM_LEAD_EDIT: 'leads/edit/:id',
  CRM_SCRIPTS: 'scripts',
  CRM_SCRIPT_NEW: 'scripts/new',
  CRM_SCRIPT_EDIT: 'scripts/:id/edit',
  CRM_CAMPAIGNS: 'campaigns',
  CRM_CAMPAIGN_NEW: 'campaigns/new',
  CRM_CAMPAIGN_EDIT: 'campaigns/:id/edit',
  CRM_EMAIL_TEMPLATES: 'templates/email',
  CRM_EMAIL_TEMPLATE_NEW: 'templates/email/new',
  CRM_EMAIL_TEMPLATE_EDIT: 'templates/email/:id',
  CRM_SMS_TEMPLATES: 'templates/sms',
  CRM_SMS_TEMPLATE_NEW: 'templates/sms/new',
  CRM_SMS_TEMPLATE_EDIT: 'templates/sms/:id',
  PT_CRM: 'personal-training-crm',
  PT_CRM_TASKS: 'tasks',
  PT_CRM_LEADS: 'leads',
  PT_CRM_LEAD_NEW: 'leads/new',
  PT_CRM_LEAD_VIEW: 'leads/:id',
  PT_CRM_LEAD_EDIT: 'leads/edit/:id',
  PT_CRM_SCRIPTS: 'scripts',
  PT_CRM_SCRIPT_NEW: 'scripts/new',
  PT_CRM_SCRIPT_EDIT: 'scripts/:id/edit',
  PT_CRM_CAMPAIGNS: 'campaigns',
  PT_CRM_CAMPAIGN_NEW: 'campaigns/new',
  PT_CRM_CAMPAIGN_EDIT: 'campaigns/:id/edit',
  PT_CRM_EMAIL_TEMPLATES: 'templates/email',
  PT_CRM_EMAIL_TEMPLATE_NEW: 'templates/email/new',
  PT_CRM_EMAIL_TEMPLATE_EDIT: 'templates/email/:id',
  PT_CRM_SMS_TEMPLATES: 'templates/sms',
  PT_CRM_SMS_TEMPLATE_NEW: 'templates/sms/new',
  PT_CRM_SMS_TEMPLATE_EDIT: 'templates/sms/:id',
  TIMECLOCK: 'timeclock',
  TIMECLOCK_LOG: 'log',
  TIMECLOCK_PAYROLL_REPORT: 'payroll-report',
  TIMECLOCK_PAYROLL_REPORT_EMPLOYEE: 'payroll-report/:id',
  DAY_SHEET: 'day-sheet',
  DAY_SHEETS: 'day-sheets',
  COMMISSION_RULES: 'commission-rules',
  COMMISSION_RULE_NEW: 'commission-rules/new',
  COMMISSION_RULE_EDIT: 'commission-rules/:id',
  REPORTS: 'reports',
  REPORT_OVERVIEW: 'overview',
  REPORT_EXTERNAL_COLLECTIONS: 'external-collections',
  REPORT_SALES_POS: 'sales-pos',
  REPORT_INVOICE_HISTORY: 'invoice-history',
  REPORT_INVOICE_HISTORY_VIEW: 'invoice-history/:id',
  REPORT_Z_OUT: 'z-out',
  REPORT_Z_OUT_VIEW: 'z-out/:id',
  REPORT_SCHEDULED_BILLINGS: 'scheduled-billings',
  REPORT_SALES_OVER_TIME: 'sales-over-time',
  REPORT_REGISTER_STATUS: 'register-status',
  REPORT_PAYMENT_TRANSACTIONS: 'payment-transactions',
  REPORT_REDEMPTIONS: 'redemptions',
  REPORT_DEPOSIT_STATEMENT: 'deposit-statement',
  REPORT_FINANCIAL_SUMMARY: 'financial-summary',
  REPORT_CHARGE_PAYMENT_ANALYSIS: 'charge-payment-analysis',
  REPORT_CRM_DASHBOARD: 'crm-dashboard',
  REPORT_CAMPAIGNS: 'campaigns',
  REPORT_CAMPAIGN_VIEW: 'campaigns/:id',
  REPORT_APPOINTMENTS: 'appointments',
  REPORT_CHECK_IN_HISTORY: 'check-in-history',
  REPORT_KID_ZONE_CHECK_IN_HISTORY: 'kidzone-check-in-history',
  CLUB_SETTINGS: 'club-settings',
  CLUB_SETTINGS_GENERAL_INFO: 'general-info',
  CLUB_SETTINGS_BANK_INFO: 'bank-info',
  CLUB_SETTINGS_BILLING: 'billing',
  CLUB_SETTINGS_FEE_RATES: 'fee-rates',
  CLUB_SETTINGS_PROCESSOR_CONFIG: 'processor-config',
  CLUB_SETTINGS_TAXPAYER: 'taxpayer',
  CLUB_SETTINGS_OTHER: 'other',
  CLUB_SETTINGS_WORKING_HOURS: 'working-hours',
  CLUB_SETTINGS_KID_ZONE_SETTINGS: 'kid-zone-settings',
  CLUB_SETTINGS_INTEGRATION: 'integration',
  CLUB_SETTINGS_SERVICES: 'services',
  CORPORATE_SETTINGS: 'corporate-settings',
  CORPORATE_SETTINGS_GENERAL_INFO: 'general-info',
  CORPORATE_SETTINGS_BANK_INFO: 'bank-info',
  CORPORATE_SETTINGS_BILLING: 'billing',
  CORPORATE_SETTINGS_PROCESSOR_CONFIG: 'processor-config',
  CORPORATE_SETTINGS_FEE_RATES: 'fee-rates',
  CORPORATE_SETTINGS_TAXPAYER: 'taxpayer',
  CORPORATE_SETTINGS_INTEGRATIONS: 'integrations',
  CORPORATE_SETTINGS_OTHER: 'other',
  CORPORATE_SETTINGS_REQUIRED_FIELDS: 'required-fields',
  CORPORATE_SETTINGS_PAY_PERIOD: 'pay-period',
  CORPORATE_SETTINGS_PAY_PERIOD_ITEM: 'pay-period/:id',
  CORPORATE_SETTINGS_SERVICES: 'services',
  PEAK_SETTINGS: 'peak-settings',
  PEAK_SETTINGS_INTEGRATIONS: 'integrations',
  PEAK_SETTINGS_FEE_RATES: 'fee-rates',
  PEAK_SETTINGS_GENERAL: 'general',
  PEAK_EMPLOYEES: 'peak-employees',
  PEAK_EMPLOYEE_NEW: 'new',
  PEAK_EMPLOYEE_EDIT: ':id/edit',
  PEAK_EMPLOYEE_VIEW: ':id/view',
  PEAK_REMITTANCE: 'remittance',
  PEAK_REMITTANCE_CALCULATE: 'calculate-remittance',
  CORPORATIONS: 'corporations',
  CORPORATION_NEW: 'new',
  CORPORATION_GENERAL_INFO: ':corporationId/general-info',
  CORPORATION_BANK_INFO: ':corporationId/bank-info',
  CORPORATION_BILLING: ':corporationId/billing',
  CORPORATION_FEE_RATES: ':corporationId/fee-rates',
  CORPORATION_PROCESSOR_CONFIG: ':corporationId/processor-config',
  CORPORATION_TAXPAYER: ':corporationId/taxpayer',
  CORPORATION_INTEGRATIONS: ':corporationId/integrations',
  CORPORATION_OTHER: ':corporationId/other',
  CORPORATION_REQUIRED_FIELDS: ':corporationId/required-fields',
  CORPORATION_PAY_PERIOD: ':corporationId/pay-period',
  CORPORATION_PAY_PERIOD_ITEM: ':corporationId/pay-period/:id',
  CORPORATION_SERVICES: ':corporationId/services',
  SERVICES_ROOT: 'services',
  SERVICES: 'services-list',
  SERVICE_NEW: 'services-list/new',
  SERVICE_EDIT: 'services-list/:serviceId',
  FEES: 'fees',
  FEE_NEW: 'fees/new',
  FEE_EDIT: 'fees/:feeId',
  SERVICE_PACKAGES: 'service-packages',
  SERVICE_PACKAGE_NEW: 'service-packages/new',
  SERVICE_PACKAGE_EDIT: 'service-packages/:packageId',
  CONTRACT_DOC_TEMPLATES: 'document-templates/contract',
  CONTRACT_DOC_TEMPLATE_NEW: 'document-templates/contract/new',
  CONTRACT_DOC_TEMPLATE_EDIT: 'document-templates/contract/:id',
  WAIVER_DOC_TEMPLATES: 'document-templates/waiver',
  WAIVER_DOC_TEMPLATE_NEW: 'document-templates/waiver/new',
  WAIVER_DOC_TEMPLATE_EDIT: 'document-templates/waiver/:id',
  POS_CONTENT: 'pos-settings',
  RECEIPTS: 'receipts',
  RECEIPT_NEW: 'receipts/new',
  RECEIPT_EDIT: 'receipts/:id/edit',
  RECEIPT_CONFIGURATION: 'receipts/:id/configuration',
  TAX_RATES: 'tax-rates',
  TAX_RATE_ViEW: 'tax-rates/:id',
  TAX_RATE_NEW: 'tax-rates/new',
  TAX_RATE_EDIT: 'tax-rates/:id/edit',
  REVENUE_CODES: 'revenue-codes',
  REVENUE_CODE_ViEW: 'revenue-codes/:id',
  REVENUE_CODE_NEW: 'revenue-codes/new',
  REVENUE_CODE_EDIT: 'revenue-codes/:id/edit',
  VENDORS: 'vendors',
  VENDOR_NEW: 'vendors/new',
  VENDOR_EDIT: 'vendors/:id/edit',
  VENDOR_VIEW: 'vendors/:id',
  INVENTORY_ITEMS: 'inventory-items',
  INVENTORY_ITEM_NEW: 'inventory-items/new',
  INVENTORY_ITEM_EDIT: 'inventory-items/:id/edit',
  INVENTORY_ITEM_CONFIGURATION: 'inventory-items/:id/configuration',
  REGISTERS: 'registers',
  REGISTER_NEW: 'register/new',
  REGISTER_EDIT: 'register/:id/edit',
  REGISTER_VIEW: 'register/:id/view',
  DEFAULT_PAYMENT_METHODS: 'payment-methods/default',
  CUSTOM_PAYMENT_METHODS: 'payment-methods/custom',
  CUSTOM_PAYMENT_METHOD_EDIT: 'payment-methods/custom/:id',
  CUSTOM_PAYMENT_METHOD_NEW: 'payment-methods/custom/:id/new',
  CUSTOM_PAYMENT_METHOD_CONFIGURATION: 'payment-methods/custom/:id/configuration/:itemId',
  PERMISSIONS: 'permissions',
  ROLES: 'roles',
  POLICIES: 'policies',
  CLUBS: 'clubs',
  CLUB_NEW: 'new',
  CLUB_EDIT_GENERAL_INFO: ':clubId/general-info',
  CLUB_EDIT_BANK_INFO: ':clubId/bank-info',
  CLUB_EDIT_BILLING: ':clubId/billing',
  CLUB_EDIT_FEE_RATES: ':clubId/fee-rates',
  CLUB_EDIT_PROCESSOR_CONFIG: ':clubId/processor-config',
  CLUB_EDIT_TAXPAYER: ':clubId/taxpayer',
  CLUB_EDIT_OTHER: ':clubId/other',
  CLUB_EDIT_WORKING_HOURS: ':clubId/working-hours',
  CLUB_EDIT_KID_ZONE_SETTINGS: ':clubId/kid-zone-settings',
  CLUB_EDIT_INTEGRATION: ':clubId/integration',
  CLUB_EDIT_SERVICES: ':clubId/services',
  COMMUNICATION: 'communication',
  COMMUNICATION_NOTIFICATIONS: 'app-push-notifications',
  COMMUNICATION_BANNERS: 'banner-ads-for-club-life',
  DICTIONARIES: 'dictionaries',
  DICTIONARY_CAME_FROM_INDICATION: 'came-from-indication',
  DICTIONARY_ADDITIONAL_GUEST_FIELDS: 'additional-guest-fields',
  DICTIONARY_ALERT_SOUND_UPLOAD: 'alert-sound-upload',
  DICTIONARY_NOTE_CODE: 'note-code',
  DICTIONARY_FALLTHROUGH_REASON: 'fallthrough-reason',
  DICTIONARY_DEPARTMENTS: 'departments',
  DICTIONARY_CLUB_GROUPS: 'club-groups',
  DICTIONARY_INSURANCE_COMPANIES: 'insurance-companies',
  DICTIONARY_ACCESS_HOURS: 'access-hours',
  DICTIONARY_EVENT_TAGS: 'event-tags',
  DICTIONARY_RESOURCE_TAGS: 'resource-tags',
  DICTIONARY_NOTIFICATIONS: 'notifications',
  DICTIONARY_NOTIFICATION_EDIT: 'notifications/:id/edit',
  DICTIONARY_NOTIFICATION_VIEW: 'notifications/:id/view',
  DICTIONARY_HELP_INFORMATION: 'help-information',
  DICTIONARY_END_REASON: 'end-reason',
  MY_PROFILE: 'my-profile',
  MY_PAYROLL_REPORT: 'my-payroll-report',
  CLIENT_ADJUSTMENTS: 'client-adjustments',
  CLIENT_ADJUSTMENTS_LIST: 'client-adjustments-list',
  RECURRING_CLIENT_ADJUSTMENTS: 'recurring-client-adjustments',
  PEAK_CLIENT_ADJUSTMENTS: 'peak-client-adjustments',
  ADJUSTMENT_CATEGORY: 'adjustment-category',
  DEPOSIT_RECONCILIATION: 'deposit-reconciliation',
  DEPOSIT_RECONCILIATION_BILLING: ':type/:createdDate/:description/:bankId/:reconciled/view',
  PEAK_REPORTS: 'peak-reports',
};

export const Routes = {
  HOME: '/',
  FRONT_DESK: `/${RouteParts.FRONT_DESK}`,
  POS: `/${RouteParts.POS}`,
  KID_ZONE: `/${RouteParts.KID_ZONE}`,
  KID_ZONE_HISTORY: `/${RouteParts.KID_ZONE}/${RouteParts.KID_ZONE_HISTORY}`,
  BOOKING: `/${RouteParts.BOOKING}`,
  BOOKING_CALENDAR: `/${RouteParts.BOOKING}/${RouteParts.BOOKING_CALENDAR}`,
  BOOKING_RESOURCES: `/${RouteParts.BOOKING}/${RouteParts.BOOKING_RESOURCES}`,
  BOOKING_RESOURCE_NEW: `/${RouteParts.BOOKING}/${RouteParts.BOOKING_RESOURCE_NEW}`,
  BOOKING_RESOURCE_EDIT: `/${RouteParts.BOOKING}/${RouteParts.BOOKING_RESOURCE_EDIT}`,
  BOOKING_SHARED: `/${RouteParts.BOOKING}/shared`,
  MEMBERS: `/${RouteParts.MEMBERS}`,
  MEMBER_NEW: `/${RouteParts.MEMBERS}/${RouteParts.MEMBER_NEW}`,
  MEMBER_VIEW: `/${RouteParts.MEMBERS}/${RouteParts.MEMBER_VIEW}`,
  EMPLOYEES: `/${RouteParts.EMPLOYEES}`,
  EMPLOYEE_NEW: `/${RouteParts.EMPLOYEES}/${RouteParts.EMPLOYEE_NEW}`,
  EMPLOYEE_VIEW: `/${RouteParts.EMPLOYEES}/${RouteParts.EMPLOYEE_VIEW}`,
  EMPLOYEE_EDIT: `/${RouteParts.EMPLOYEES}/${RouteParts.EMPLOYEE_EDIT}`,
  CRM: `/${RouteParts.CRM}`,
  CRM_TASKS: `/${RouteParts.CRM}/${RouteParts.CRM_TASKS}`,
  CRM_LEADS: `/${RouteParts.CRM}/${RouteParts.CRM_LEADS}`,
  CRM_LEAD_NEW: `/${RouteParts.CRM}/${RouteParts.CRM_LEAD_NEW}`,
  CRM_LEAD_VIEW: `/${RouteParts.CRM}/${RouteParts.CRM_LEAD_VIEW}`,
  CRM_LEAD_EDIT: `/${RouteParts.CRM}/${RouteParts.CRM_LEAD_EDIT}`,
  CRM_SCRIPTS: `/${RouteParts.CRM}/${RouteParts.CRM_SCRIPTS}`,
  CRM_SCRIPT_NEW: `/${RouteParts.CRM}/${RouteParts.CRM_SCRIPT_NEW}`,
  CRM_SCRIPT_EDIT: `/${RouteParts.CRM}/${RouteParts.CRM_SCRIPT_EDIT}`,
  CRM_CAMPAIGNS: `/${RouteParts.CRM}/${RouteParts.CRM_CAMPAIGNS}`,
  CRM_CAMPAIGN_NEW: `/${RouteParts.CRM}/${RouteParts.CRM_CAMPAIGN_NEW}`,
  CRM_CAMPAIGN_EDIT: `/${RouteParts.CRM}/${RouteParts.CRM_CAMPAIGN_EDIT}`,
  CRM_EMAIL_TEMPLATES: `/${RouteParts.CRM}/${RouteParts.CRM_EMAIL_TEMPLATES}`,
  CRM_EMAIL_TEMPLATE_NEW: `/${RouteParts.CRM}/${RouteParts.CRM_EMAIL_TEMPLATE_NEW}`,
  CRM_EMAIL_TEMPLATE_EDIT: `/${RouteParts.CRM}/${RouteParts.CRM_EMAIL_TEMPLATE_EDIT}`,
  CRM_SMS_TEMPLATES: `/${RouteParts.CRM}/${RouteParts.CRM_SMS_TEMPLATES}`,
  CRM_SMS_TEMPLATE_NEW: `/${RouteParts.CRM}/${RouteParts.CRM_SMS_TEMPLATE_NEW}`,
  CRM_SMS_TEMPLATE_EDIT: `/${RouteParts.CRM}/${RouteParts.CRM_SMS_TEMPLATE_EDIT}`,
  PT_CRM: `/${RouteParts.PT_CRM}`,
  PT_CRM_TASKS: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_TASKS}`,
  PT_CRM_LEADS: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_LEADS}`,
  PT_CRM_LEAD_NEW: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_LEAD_NEW}`,
  PT_CRM_LEAD_VIEW: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_LEAD_VIEW}`,
  PT_CRM_LEAD_EDIT: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_LEAD_EDIT}`,
  PT_CRM_SCRIPTS: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_SCRIPTS}`,
  PT_CRM_SCRIPT_NEW: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_SCRIPT_NEW}`,
  PT_CRM_SCRIPT_EDIT: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_SCRIPT_EDIT}`,
  PT_CRM_CAMPAIGNS: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_CAMPAIGNS}`,
  PT_CRM_CAMPAIGN_NEW: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_CAMPAIGN_NEW}`,
  PT_CRM_CAMPAIGN_EDIT: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_CAMPAIGN_EDIT}`,
  PT_CRM_EMAIL_TEMPLATES: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_EMAIL_TEMPLATES}`,
  PT_CRM_EMAIL_TEMPLATE_NEW: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_EMAIL_TEMPLATE_NEW}`,
  PT_CRM_EMAIL_TEMPLATE_EDIT: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_EMAIL_TEMPLATE_EDIT}`,
  PT_CRM_SMS_TEMPLATES: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_SMS_TEMPLATES}`,
  PT_CRM_SMS_TEMPLATE_NEW: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_SMS_TEMPLATE_NEW}`,
  PT_CRM_SMS_TEMPLATE_EDIT: `/${RouteParts.PT_CRM}/${RouteParts.PT_CRM_SMS_TEMPLATE_EDIT}`,
  TIMECLOCK: `/${RouteParts.TIMECLOCK}`,
  TIMECLOCK_LOG: `/${RouteParts.TIMECLOCK}/${RouteParts.TIMECLOCK_LOG}`,
  TIMECLOCK_PAYROLL_REPORT: `/${RouteParts.TIMECLOCK}/${RouteParts.TIMECLOCK_PAYROLL_REPORT}`,
  TIMECLOCK_PAYROLL_REPORT_EMPLOYEE: `/${RouteParts.TIMECLOCK}/${RouteParts.TIMECLOCK_PAYROLL_REPORT_EMPLOYEE}`,
  DAY_SHEET: `/${RouteParts.DAY_SHEET}`,
  DAY_SHEETS: `/${RouteParts.DAY_SHEET}/${RouteParts.DAY_SHEETS}`,
  COMMISSION_RULES: `/${RouteParts.DAY_SHEET}/${RouteParts.COMMISSION_RULES}`,
  COMMISSION_RULE_NEW: `/${RouteParts.DAY_SHEET}/${RouteParts.COMMISSION_RULE_NEW}`,
  COMMISSION_RULE_EDIT: `/${RouteParts.DAY_SHEET}/${RouteParts.COMMISSION_RULE_EDIT}`,
  REPORTS: `/${RouteParts.REPORTS}`,
  REPORT_OVERVIEW: `/${RouteParts.REPORTS}/${RouteParts.REPORT_OVERVIEW}`,
  REPORT_EXTERNAL_COLLECTIONS: `/${RouteParts.REPORTS}/${RouteParts.REPORT_EXTERNAL_COLLECTIONS}`,
  REPORT_SALES_POS: `/${RouteParts.REPORTS}/${RouteParts.REPORT_SALES_POS}`,
  REPORT_INVOICE_HISTORY: `/${RouteParts.REPORTS}/${RouteParts.REPORT_INVOICE_HISTORY}`,
  REPORT_INVOICE_HISTORY_VIEW: `/${RouteParts.REPORTS}/${RouteParts.REPORT_INVOICE_HISTORY_VIEW}`,
  REPORT_Z_OUT: `/${RouteParts.REPORTS}/${RouteParts.REPORT_Z_OUT}`,
  REPORT_Z_OUT_VIEW: `/${RouteParts.REPORTS}/${RouteParts.REPORT_Z_OUT_VIEW}`,
  REPORT_SCHEDULED_BILLINGS: `/${RouteParts.REPORTS}/${RouteParts.REPORT_SCHEDULED_BILLINGS}`,
  REPORT_SALES_OVER_TIME: `/${RouteParts.REPORTS}/${RouteParts.REPORT_SALES_OVER_TIME}`,
  REPORT_REGISTER_STATUS: `/${RouteParts.REPORTS}/${RouteParts.REPORT_REGISTER_STATUS}`,
  REPORT_PAYMENT_TRANSACTIONS: `/${RouteParts.REPORTS}/${RouteParts.REPORT_PAYMENT_TRANSACTIONS}`,
  REPORT_REDEMPTIONS: `/${RouteParts.REPORTS}/${RouteParts.REPORT_REDEMPTIONS}`,
  REPORT_DEPOSIT_STATEMENT: `/${RouteParts.REPORTS}/${RouteParts.REPORT_DEPOSIT_STATEMENT}`,
  REPORT_FINANCIAL_SUMMARY: `/${RouteParts.REPORTS}/${RouteParts.REPORT_FINANCIAL_SUMMARY}`,
  REPORT_CHARGE_PAYMENT_ANALYSIS: `/${RouteParts.REPORTS}/${RouteParts.REPORT_CHARGE_PAYMENT_ANALYSIS}`,
  REPORT_CRM_DASHBOARD: `/${RouteParts.REPORTS}/${RouteParts.REPORT_CRM_DASHBOARD}`,
  REPORT_CAMPAIGNS: `/${RouteParts.REPORTS}/${RouteParts.REPORT_CAMPAIGNS}`,
  REPORT_CAMPAIGN_VIEW: `/${RouteParts.REPORTS}/${RouteParts.REPORT_CAMPAIGN_VIEW}`,
  REPORT_APPOINTMENTS: `/${RouteParts.REPORTS}/${RouteParts.REPORT_APPOINTMENTS}`,
  REPORT_CHECK_IN_HISTORY: `/${RouteParts.REPORTS}/${RouteParts.REPORT_CHECK_IN_HISTORY}`,
  REPORT_KID_ZONE_CHECK_IN_HISTORY: `/${RouteParts.REPORTS}/${RouteParts.REPORT_KID_ZONE_CHECK_IN_HISTORY}`,
  CLUB_SETTINGS: `/${RouteParts.CLUB_SETTINGS}`,
  CLUB_SETTINGS_GENERAL_INFO: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_GENERAL_INFO}`,
  CLUB_SETTINGS_BANK_INFO: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_BANK_INFO}`,
  CLUB_SETTINGS_BILLING: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_BILLING}`,
  CLUB_SETTINGS_FEE_RATES: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_FEE_RATES}`,
  CLUB_SETTINGS_PROCESSOR_CONFIG: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_PROCESSOR_CONFIG}`,
  CLUB_SETTINGS_TAXPAYER: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_TAXPAYER}`,
  CLUB_SETTINGS_OTHER: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_OTHER}`,
  CLUB_SETTINGS_WORKING_HOURS: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_WORKING_HOURS}`,
  CLUB_SETTINGS_KID_ZONE_SETTINGS: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_KID_ZONE_SETTINGS}`,
  CLUB_SETTINGS_INTEGRATION: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_INTEGRATION}`,
  CLUB_SETTINGS_SERVICES: `/${RouteParts.CLUB_SETTINGS}/${RouteParts.CLUB_SETTINGS_SERVICES}`,
  CORPORATE_SETTINGS: `/${RouteParts.CORPORATE_SETTINGS}`,
  CORPORATE_SETTINGS_GENERAL_INFO: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_GENERAL_INFO}`,
  CORPORATE_SETTINGS_BANK_INFO: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_BANK_INFO}`,
  CORPORATE_SETTINGS_BILLING: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_BILLING}`,
  CORPORATE_SETTINGS_PROCESSOR_CONFIG: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_PROCESSOR_CONFIG}`,
  CORPORATE_SETTINGS_FEE_RATES: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_FEE_RATES}`,
  CORPORATE_SETTINGS_TAXPAYER: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_TAXPAYER}`,
  CORPORATE_SETTINGS_INTEGRATIONS: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_INTEGRATIONS}`,
  CORPORATE_SETTINGS_OTHER: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_OTHER}`,
  CORPORATE_SETTINGS_REQUIRED_FIELDS: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_REQUIRED_FIELDS}`,
  CORPORATE_SETTINGS_PAY_PERIOD: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_PAY_PERIOD}`,
  CORPORATE_SETTINGS_PAY_PERIOD_ITEM: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_PAY_PERIOD_ITEM}`,
  CORPORATE_SETTINGS_SERVICES: `/${RouteParts.CORPORATE_SETTINGS}/${RouteParts.CORPORATE_SETTINGS_SERVICES}`,
  PEAK_SETTINGS: `/${RouteParts.PEAK_SETTINGS}`,
  PEAK_SETTINGS_INTEGRATIONS: `/${RouteParts.PEAK_SETTINGS}/${RouteParts.PEAK_SETTINGS_INTEGRATIONS}`,
  PEAK_SETTINGS_FEE_RATES: `/${RouteParts.PEAK_SETTINGS}/${RouteParts.PEAK_SETTINGS_FEE_RATES}`,
  PEAK_SETTINGS_GENERAL: `/${RouteParts.PEAK_SETTINGS}/${RouteParts.PEAK_SETTINGS_GENERAL}`,
  PEAK_EMPLOYEES: `/${RouteParts.PEAK_EMPLOYEES}`,
  PEAK_EMPLOYEE_NEW: `/${RouteParts.PEAK_EMPLOYEES}/${RouteParts.PEAK_EMPLOYEE_NEW}`,
  PEAK_EMPLOYEE_EDIT: `/${RouteParts.PEAK_EMPLOYEES}/${RouteParts.PEAK_EMPLOYEE_EDIT}`,
  PEAK_EMPLOYEE_VIEW: `/${RouteParts.PEAK_EMPLOYEES}/${RouteParts.PEAK_EMPLOYEE_VIEW}`,
  PEAK_REMITTANCE: `/${RouteParts.PEAK_REMITTANCE}`,
  PEAK_REMITTANCE_CALCULATE: `/${RouteParts.PEAK_REMITTANCE}/${RouteParts.PEAK_REMITTANCE_CALCULATE}`,
  CORPORATIONS: `/${RouteParts.CORPORATIONS}`,
  CORPORATION_NEW: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_NEW}`,
  CORPORATION_GENERAL_INFO: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_GENERAL_INFO}`,
  CORPORATION_BANK_INFO: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_BANK_INFO}`,
  CORPORATION_BILLING: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_BILLING}`,
  CORPORATION_FEE_RATES: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_FEE_RATES}`,
  CORPORATION_PROCESSOR_CONFIG: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_PROCESSOR_CONFIG}`,
  CORPORATION_TAXPAYER: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_TAXPAYER}`,
  CORPORATION_INTEGRATIONS: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_INTEGRATIONS}`,
  CORPORATION_OTHER: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_OTHER}`,
  CORPORATION_REQUIRED_FIELDS: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_REQUIRED_FIELDS}`,
  CORPORATION_PAY_PERIOD: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_PAY_PERIOD}`,
  CORPORATION_PAY_PERIOD_ITEM: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_PAY_PERIOD_ITEM}`,
  CORPORATION_SERVICES: `/${RouteParts.CORPORATIONS}/${RouteParts.CORPORATION_SERVICES}`,
  SERVICES_ROOT: `/${RouteParts.SERVICES_ROOT}`,
  SERVICES: `/${RouteParts.SERVICES_ROOT}/${RouteParts.SERVICES}`,
  SERVICE_NEW: `/${RouteParts.SERVICES_ROOT}/${RouteParts.SERVICE_NEW}`,
  SERVICE_EDIT: `/${RouteParts.SERVICES_ROOT}/${RouteParts.SERVICE_EDIT}`,
  FEES: `/${RouteParts.SERVICES_ROOT}/${RouteParts.FEES}`,
  FEE_NEW: `/${RouteParts.SERVICES_ROOT}/${RouteParts.FEE_NEW}`,
  FEE_EDIT: `/${RouteParts.SERVICES_ROOT}/${RouteParts.FEE_EDIT}`,
  SERVICE_PACKAGES: `/${RouteParts.SERVICES_ROOT}/${RouteParts.SERVICE_PACKAGES}`,
  SERVICE_PACKAGE_NEW: `/${RouteParts.SERVICES_ROOT}/${RouteParts.SERVICE_PACKAGE_NEW}`,
  SERVICE_PACKAGE_EDIT: `/${RouteParts.SERVICES_ROOT}/${RouteParts.SERVICE_PACKAGE_EDIT}`,
  CONTRACT_DOC_TEMPLATES: `/${RouteParts.SERVICES_ROOT}/${RouteParts.CONTRACT_DOC_TEMPLATES}`,
  CONTRACT_DOC_TEMPLATE_NEW: `/${RouteParts.SERVICES_ROOT}/${RouteParts.CONTRACT_DOC_TEMPLATE_NEW}`,
  CONTRACT_DOC_TEMPLATE_EDIT: `/${RouteParts.SERVICES_ROOT}/${RouteParts.CONTRACT_DOC_TEMPLATE_EDIT}`,
  WAIVER_DOC_TEMPLATES: `/${RouteParts.SERVICES_ROOT}/${RouteParts.WAIVER_DOC_TEMPLATES}`,
  WAIVER_DOC_TEMPLATE_NEW: `/${RouteParts.SERVICES_ROOT}/${RouteParts.WAIVER_DOC_TEMPLATE_NEW}`,
  WAIVER_DOC_TEMPLATE_EDIT: `/${RouteParts.SERVICES_ROOT}/${RouteParts.WAIVER_DOC_TEMPLATE_EDIT}`,
  POS_CONTENT: `/${RouteParts.POS_CONTENT}`,
  RECEIPTS: `/${RouteParts.POS_CONTENT}/${RouteParts.RECEIPTS}`,
  RECEIPT_NEW: `/${RouteParts.POS_CONTENT}/${RouteParts.RECEIPT_NEW}`,
  RECEIPT_EDIT: `/${RouteParts.POS_CONTENT}/${RouteParts.RECEIPT_EDIT}`,
  RECEIPT_CONFIGURATION: `/${RouteParts.POS_CONTENT}/${RouteParts.RECEIPT_CONFIGURATION}`,
  TAX_RATES: `/${RouteParts.POS_CONTENT}/${RouteParts.TAX_RATES}`,
  TAX_RATE_ViEW: `/${RouteParts.POS_CONTENT}/${RouteParts.TAX_RATE_ViEW}`,
  TAX_RATE_NEW: `/${RouteParts.POS_CONTENT}/${RouteParts.TAX_RATE_NEW}`,
  TAX_RATE_EDIT: `/${RouteParts.POS_CONTENT}/${RouteParts.TAX_RATE_EDIT}`,
  REVENUE_CODES: `/${RouteParts.POS_CONTENT}/${RouteParts.REVENUE_CODES}`,
  REVENUE_CODE_ViEW: `/${RouteParts.POS_CONTENT}/${RouteParts.REVENUE_CODE_ViEW}`,
  REVENUE_CODE_NEW: `/${RouteParts.POS_CONTENT}/${RouteParts.REVENUE_CODE_NEW}`,
  REVENUE_CODE_EDIT: `/${RouteParts.POS_CONTENT}/${RouteParts.REVENUE_CODE_EDIT}`,
  VENDORS: `/${RouteParts.POS_CONTENT}/${RouteParts.VENDORS}`,
  VENDOR_NEW: `/${RouteParts.POS_CONTENT}/${RouteParts.VENDOR_NEW}`,
  VENDOR_EDIT: `/${RouteParts.POS_CONTENT}/${RouteParts.VENDOR_EDIT}`,
  VENDOR_VIEW: `/${RouteParts.POS_CONTENT}/${RouteParts.VENDOR_VIEW}`,
  INVENTORY_ITEMS: `/${RouteParts.POS_CONTENT}/${RouteParts.INVENTORY_ITEMS}`,
  INVENTORY_ITEM_NEW: `/${RouteParts.POS_CONTENT}/${RouteParts.INVENTORY_ITEM_NEW}`,
  INVENTORY_ITEM_EDIT: `/${RouteParts.POS_CONTENT}/${RouteParts.INVENTORY_ITEM_EDIT}`,
  INVENTORY_ITEM_CONFIGURATION: `/${RouteParts.POS_CONTENT}/${RouteParts.INVENTORY_ITEM_CONFIGURATION}`,
  REGISTERS: `/${RouteParts.POS_CONTENT}/${RouteParts.REGISTERS}`,
  REGISTER_NEW: `/${RouteParts.POS_CONTENT}/${RouteParts.REGISTER_NEW}`,
  REGISTER_EDIT: `/${RouteParts.POS_CONTENT}/${RouteParts.REGISTER_EDIT}`,
  REGISTER_VIEW: `/${RouteParts.POS_CONTENT}/${RouteParts.REGISTER_VIEW}`,
  DEFAULT_PAYMENT_METHODS: `/${RouteParts.POS_CONTENT}/${RouteParts.DEFAULT_PAYMENT_METHODS}`,
  CUSTOM_PAYMENT_METHODS: `/${RouteParts.POS_CONTENT}/${RouteParts.CUSTOM_PAYMENT_METHODS}`,
  CUSTOM_PAYMENT_METHOD_EDIT: `/${RouteParts.POS_CONTENT}/${RouteParts.CUSTOM_PAYMENT_METHOD_EDIT}`,
  CUSTOM_PAYMENT_METHOD_NEW: `/${RouteParts.POS_CONTENT}/${RouteParts.CUSTOM_PAYMENT_METHOD_NEW}`,
  CUSTOM_PAYMENT_METHOD_CONFIGURATION: `/${RouteParts.POS_CONTENT}/${RouteParts.CUSTOM_PAYMENT_METHOD_CONFIGURATION}`,
  PERMISSIONS: `/${RouteParts.PERMISSIONS}`,
  ROLES: `/${RouteParts.PERMISSIONS}/${RouteParts.ROLES}`,
  POLICIES: `/${RouteParts.PERMISSIONS}/${RouteParts.POLICIES}`,
  CLUBS: `/${RouteParts.CLUBS}`,
  CLUB_NEW: `/${RouteParts.CLUBS}/${RouteParts.CLUB_NEW}`,
  CLUB_EDIT_GENERAL_INFO: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_GENERAL_INFO}`,
  CLUB_EDIT_BANK_INFO: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_BANK_INFO}`,
  CLUB_EDIT_BILLING: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_BILLING}`,
  CLUB_EDIT_FEE_RATES: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_FEE_RATES}`,
  CLUB_EDIT_PROCESSOR_CONFIG: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_PROCESSOR_CONFIG}`,
  CLUB_EDIT_TAXPAYER: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_TAXPAYER}`,
  CLUB_EDIT_OTHER: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_OTHER}`,
  CLUB_EDIT_WORKING_HOURS: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_WORKING_HOURS}`,
  CLUB_EDIT_KID_ZONE_SETTINGS: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_KID_ZONE_SETTINGS}`,
  CLUB_EDIT_INTEGRATION: `/${RouteParts.CLUBS}/${RouteParts.CLUB_EDIT_INTEGRATION}`,
  COMMUNICATION: `/${RouteParts.COMMUNICATION}`,
  COMMUNICATION_NOTIFICATIONS: `/${RouteParts.COMMUNICATION}/${RouteParts.COMMUNICATION_NOTIFICATIONS}`,
  COMMUNICATION_BANNERS: `/${RouteParts.COMMUNICATION}/${RouteParts.COMMUNICATION_BANNERS}`,
  DICTIONARIES: `/${RouteParts.DICTIONARIES}`,
  DICTIONARY_CAME_FROM_INDICATION: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_CAME_FROM_INDICATION}`,
  DICTIONARY_ADDITIONAL_GUEST_FIELDS: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_ADDITIONAL_GUEST_FIELDS}`,
  DICTIONARY_ALERT_SOUND_UPLOAD: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_ALERT_SOUND_UPLOAD}`,
  DICTIONARY_NOTE_CODE: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_NOTE_CODE}`,
  DICTIONARY_FALLTHROUGH_REASON: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_FALLTHROUGH_REASON}`,
  DICTIONARY_DEPARTMENTS: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_DEPARTMENTS}`,
  DICTIONARY_CLUB_GROUPS: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_CLUB_GROUPS}`,
  DICTIONARY_INSURANCE_COMPANIES: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_INSURANCE_COMPANIES}`,
  DICTIONARY_ACCESS_HOURS: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_ACCESS_HOURS}`,
  DICTIONARY_EVENT_TAGS: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_EVENT_TAGS}`,
  DICTIONARY_RESOURCE_TAGS: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_RESOURCE_TAGS}`,
  DICTIONARY_NOTIFICATIONS: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_NOTIFICATIONS}`,
  DICTIONARY_NOTIFICATION_EDIT: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_NOTIFICATION_EDIT}`,
  DICTIONARY_NOTIFICATION_VIEW: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_NOTIFICATION_VIEW}`,
  DICTIONARY_HELP_INFORMATION: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_HELP_INFORMATION}`,
  DICTIONARY_END_REASON: `/${RouteParts.DICTIONARIES}/${RouteParts.DICTIONARY_END_REASON}`,
  DICTIONARY_ADJUSTMENT_CATEGORY: `/${RouteParts.DICTIONARIES}/${RouteParts.ADJUSTMENT_CATEGORY}`,
  MY_PROFILE: `/${RouteParts.MY_PROFILE}`,
  MY_PAYROLL_REPORT: `/${RouteParts.MY_PROFILE}/${RouteParts.MY_PAYROLL_REPORT}`,
  PRIVACY_POLICY: '/privacy-policy',
  COOKIE_POLICY: '/cookie-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  SIGN_IN: '/sign-in',
  CLIENT_ADJUSTMENTS: `/${RouteParts.CLIENT_ADJUSTMENTS}`,
  CLIENT_ADJUSTMENTS_LIST: `/${RouteParts.CLIENT_ADJUSTMENTS}/${RouteParts.CLIENT_ADJUSTMENTS_LIST}`,
  RECURRING_CLIENT_ADJUSTMENTS: `/${RouteParts.CLIENT_ADJUSTMENTS}/${RouteParts.RECURRING_CLIENT_ADJUSTMENTS}`,
  PEAK_CLIENT_ADJUSTMENTS: `/${RouteParts.PEAK_CLIENT_ADJUSTMENTS}`,
  PEAK_CLIENT_ADJUSTMENTS_LIST: `/${RouteParts.PEAK_CLIENT_ADJUSTMENTS}/${RouteParts.CLIENT_ADJUSTMENTS_LIST}`,
  PEAK_RECURRING_CLIENT_ADJUSTMENTS: `/${RouteParts.PEAK_CLIENT_ADJUSTMENTS}/${RouteParts.RECURRING_CLIENT_ADJUSTMENTS}`,
  DEPOSIT_RECONCILIATION: `/${RouteParts.DEPOSIT_RECONCILIATION}`,
  DEPOSIT_RECONCILIATION_BILLING: `/${RouteParts.DEPOSIT_RECONCILIATION}/${RouteParts.DEPOSIT_RECONCILIATION_BILLING}`,
  PEAK_REPORTS: `/${RouteParts.PEAK_REPORTS}`,
  PEAK_REPORT_PAYMENT_TRANSACTIONS: `/${RouteParts.PEAK_REPORTS}/${RouteParts.REPORT_PAYMENT_TRANSACTIONS}`,
};

export const MemberPortalRoutes = {
  PROFILE: '/profile',
  BOOKING: '/booking',
  REPORTS: '/reports',
  CLUBS: '/clubs',
};
